import React from 'react';
import { isEmptyObject } from '../../utils';
import { FormField } from '../FormField';
import { InputField } from '../InputField';
import { ModuleComponents } from '../ModuleComponents';

interface FieldsProps {
    // fields: Field[];
    fields: any;
    fieldValues: any;
    setFieldValues: any;
    fieldErrors?: any;
    setFieldErrors?: any;
    /**
     * We have two different input types used in various forms. The formField is used
     * mostly in FirebaseForms.
     */
    inputType?: 'formField' | 'inputField' | 'markdown';
    className?: string;
}

export const Fields: React.FC<FieldsProps> = ({
    fields,
    fieldValues,
    setFieldValues,
    fieldErrors,
    setFieldErrors,
    inputType = 'inputField',
    className,
}) => {
    /** @type {ChangeFieldValue} */
    const handleFieldValueChange = (event: any) => {
        const { value, name, checked } = event.target;

        if (event.target.type === 'checkbox') {
            setFieldValues({ ...fieldValues, [name]: checked });
        } else {
            setFieldValues({ ...fieldValues, [name]: value });
        }

        /**
         * Removes error indication when user tries to correct the field value
         */
        if (!isEmptyObject(fieldErrors) && setFieldErrors) {
            setFieldErrors({ ...fieldErrors, [name]: '' });
        }
    };

    return (
        <>
            {fields.map((field: any) => {
                const {
                    _uid,
                    label,
                    ruleLabel,
                    type,
                    name,
                    placeholder,
                    required,
                    disabled,
                    pattern,
                    variant,
                } = field;

                const inputSharedProps = {
                    key: _uid,
                    name,
                    value: fieldValues[name] || '',
                    inputType: type,
                    placeholder,
                    onChange: handleFieldValueChange,
                    dataEvent: `profile form (field ${field.name})`,
                    required,
                    error: fieldErrors && Boolean(fieldErrors[name]),
                    errorMsg: fieldErrors && fieldErrors[name],
                    pattern: pattern || '',
                };

                if (field.component === 'submit') {
                    return (
                        <ModuleComponents
                            key={_uid}
                            components={field.button}
                        />
                    );
                }

                if (field.component === 'Markdown') {
                    return <ModuleComponents key={_uid} components={[field]} />;
                }

                if (field.component === 'radioGroup') {
                    return (
                        <div key={_uid}>
                            <fieldset
                                id={field.name}
                                style={{ border: 'none' }}
                            >
                                {field.options.map((option: any) => {
                                    return (
                                        <div key={option._uid}>
                                            <input
                                                type="radio"
                                                value={option.label}
                                                name={field.name}
                                            />
                                            {option.label}
                                        </div>
                                    );
                                })}
                            </fieldset>
                        </div>
                    );
                }

                switch (inputType) {
                    case 'inputField':
                        // @ts-ignore TODO
                        return <InputField {...inputSharedProps} />;
                    case 'formField':
                    default:
                        return (
                            // @ts-ignore TODO
                            <FormField
                                {...inputSharedProps}
                                label={label}
                                ruleLabel={ruleLabel}
                                disabled={disabled}
                                className={className}
                                variant={variant}
                            />
                        );
                }
            })}
        </>
    );
};
